/* eslint-disable @typescript-eslint/no-unused-vars */
/** @jsx jsx */

import React, { useEffect, useMemo, useState } from 'react';
import {useHistory } from 'react-router-dom';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import FormContents from 'components/atoms/Form/FormContents';
import { css, jsx } from '@emotion/core';
import {
  Container, Row, Col,
} from 'react-grid-system';
import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import moment from 'moment';
import BodyText from 'components/atoms/BodyText';
import Button, { PrimaryButton, DeleteButton } from 'components/atoms/Button';
import ConfirmModal from 'components/organismos/ConfirmModal';
import TextForm from 'components/molecules/TextForm';
import FormField from 'components/atoms/Form/FormField';
import BlockUI from 'components/molecules/BlockUi';
import {textFontSize, textColor, grayScale } from 'components/styles';
import FlexBox from 'components/atoms/FlexBox';
import Table from 'components/molecules/Table';
import ToastModal from '../../../../organismos/ToastModal';
import { HolidayWorkApplicationForm } from './hooks';
import FormPadding from 'components/atoms/Form/FormPadding';
// import LableTitle from 'components/atoms/LableTitle';
// import DataTable from 'components/organismos/DataTable/DataTable';
// import { Column } from 'react-table';
import LableTitle from 'components/atoms/LableTitle';
import DataTable from 'components/organismos/DataTable/DataTable';
import { Column } from 'react-table';
import FormTitle from 'components/atoms/Form/FormTitle';
import SelectForm from 'components/molecules/SelectForm';
import HistoryApprovalTable from 'components/molecules/HistoryApprovalTable';
import AttendHolidayworkModal from 'components/molecules/ChangeLogModal/Template/AttendHolidayworkModal';
import TabControl from 'components/atoms/TabControl';
import FormHeader from 'components/templates/FormHeader';

const styles = {
  container: {
    marginTop: '30px'
  },
  tableContent: css({
    justifyContent: 'center',
    alignItems: 'center'
  }),
  colorText: css({
    color: grayScale.gray100,
  }),
  approvalWrap: css({
    padding: '0px',
    marginBottom: '15px',
    marginTop: '0px'
  }),
  formContent: {
    paddingBottom: "16px"
  }
};

const HolidayWorkApplicationPage: React.FC = () => {
  const history = useHistory();
  const {
    formik,
    orgTreesOptions,
    targetDate,
    toastMessage,
    toastModalOpen,
    setToastModalOpen,
    confirmApplyModalOpen,
    closeConfirmApplyModal,
    isLoading,
    dispStaffName,
    setSelectOrgCode,
    isGetHolidayWorkSuccees,
    selectChangelog,
    setSelectChangelog,
    fetchChangeLogHolidayWork
  } = HolidayWorkApplicationForm();

  const columns: Array<any> = useMemo(() => [
    {
      Header: 'No',
      accessor: 'version',
    },
    {
      Header: '申請種別',
      id: 'modifiyStatus',
      accessor: 'modifiyStatus',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.modifiyStatus === 0) {
          return '申請';
        }
        if (cell.row.original.modifiyStatus === 1) {
          return '削除';
        }
        if (cell.row.original.modifiyStatus !== 0 && cell.row.original.modifiyStatus !== 1) {
          return '';
        }
      },
    },
    {
      Header: '日付',
      id: 'targetDate',
      accessor: 'targetDate',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.targetDate != null) {
          return moment(cell.row.original.targetDate).format('YYYY/MM/DD(ddd)');
        }
        if (cell.row.original.targetDate == null) {
          return '';
        }
      },
    },
    {
      Header: '申請日時',
      id: 'applicationOvertime',
      accessor: 'applicationOvertime',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.applicationDate != null) {
          return moment(cell.row.original.applicationDate).format('YYYY/MM/DD HH:mm:ss');
        }
        if (cell.row.original.applicationDate == null) {
          return '';
        }
      },
    },
    {
      Header: '申請者',
      id: 'applicationStaffCode',
      accessor: 'applicationStaffCode',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        return (
          <span>
            <div>{cell.row.original.applicationStaffCode}<br></br>{cell.row.original.applicationStaffName}</div>
          </span>
        );
      },
    },
    {
      Header: '申請理由	',
      accessor: 'applicationReason',
    },
    {
      Header: '決裁状況	',
      id: 'applicationStatus',
      accessor: 'applicationStatus',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.applicationStatus === 0) {
          return '申請中';
        }
        if (cell.row.original.applicationStatus === 1) {
          return '承認';
        }
        if (cell.row.original.applicationStatus === 2) {
          return '差戻';
        }
        if (cell.row.original.applicationStatus !== 0 && cell.row.original.applicationStatus !== 1 && cell.row.original.applicationStatus !== 2) {
          return '';
        }
      },
    },
    {
      Header: '決裁日時	',
      id: 'approvalDate',
      accessor: 'approvalDate',
      Cell: (cell: { row: { isExpanded: boolean, original: any }, page: [] }) => {
        if (cell.row.original.approvalDate != null) {
          return moment(cell.row.original.approvalDate).format('YYYY/MM/DD HH:mm:ss');
        }
        if (cell.row.original.approvalDate == null) {
          return '';
        }
      },
    },
    {
      Header: '差戻コメント',
      accessor: 'rejectReason',
    },
  ], []);

  const sortBy = React.useMemo(
    () => [
      {
        id: 'no',
        desc: false,
      },
    ],
    [],
  );

  const [changeLogData, setChangeLogData] = useState<Array<any>>([]);

  useEffect(() => {
    if (formik.values.orgCode || formik.values.targetDate || formik.values.staffCode) {
      fetchChangeLogHolidayWork(formik.values.orgCode, formik.values.targetDateStr, formik.values.staffCode).then(
        res => {
          setChangeLogData(res);
        }
      );
    }
  }, [formik.values.orgCode, formik.values.targetDate, formik.values.staffCode]);

  return (
    <SidebarTemplate>
      <BlockUI blocking={isLoading}>
      <FormHeader title="休日出勤申請"/>
        <FormContents customStyle={css({marginTop:'60px'})}>
          <form onSubmit={formik.handleSubmit}>
            <Container fluid={true}>
              <FormPadding customStyle={css({paddingTop:'16px'})} >
                <Row >
                  <Col md={2} xs={12}>
                    <BodyText>日時</BodyText>
                  </Col>
                  <Col md={6} xs={12}>
                    <BodyText customStyle={styles.colorText}>
                      {moment(`${targetDate}`).format('YYYY年MM月DD日(ddd)')}
                    </BodyText>
                  </Col>
                </Row>
                </FormPadding>
                <FormPadding>
                <Row>
                  <Col md={2} xs={12}>
                    <BodyText>スタッフ</BodyText>
                  </Col>
                  <Col md={6} xs={12}>
                    <BodyText customStyle={styles.colorText}>
                      {dispStaffName}
                    </BodyText>
                  </Col>
                </Row>   
                </FormPadding> 
                <FormPadding>
                {
                  isGetHolidayWorkSuccees && (
                    <Row>
                      { formik.values.modifierApplicationId === null && (
                        <React.Fragment>
                          <Col style={{ display: 'flex', alignItems: 'center' }} md={2} xs={12}>
                            <BodyText>出勤組織</BodyText>
                          </Col>
                          <Col xl={5} md={6} xs={12}>
                            <VerticalLabelSelectForm
                              label=""
                              name="orgCode"
                              value={String(formik.values.orgCode)}
                              setValue={(val: string) => setSelectOrgCode(val)}
                              options={orgTreesOptions}
                              required={false}
                              ghost={(['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") === -1 && orgTreesOptions.length === 1)}
                              disable={formik.values.applicationStatus === 0}
                            />
                          </Col>
                        </React.Fragment>
                      )}
                      {
                        formik.values.modifierApplicationId !== null && (
                          <Col xs={12}>
                            <Row>
                              <Col md={2} xs={12}>
                                <BodyText>出勤組織</BodyText>
                              </Col>
                              <Col md={6} xs={12}>
                                <BodyText customStyle={styles.colorText}>
                                  {formik.values.orgName}
                                </BodyText>
                              </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                          </Col>
                        )
                      }
                    </Row>
                  )
                }
                </FormPadding>

              <Row className="table-padding">
                <Table customStyle={styles.container}>
                  <thead>
                    <tr>
                      <Table.HeaderCell>出勤時間</Table.HeaderCell>
                      <Table.HeaderCell>退勤時間</Table.HeaderCell>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <Table.Cell>
                        <FlexBox customStyle={styles.tableContent}>
                          {(formik.values.workTimeData != null && formik.values.workTimeData.startTime) ? formik.values.workTimeData.startTime : ''}
                      &nbsp;
                    </FlexBox>
                      </Table.Cell>
                      <Table.Cell>
                        <FlexBox customStyle={styles.tableContent}>
                          {(formik.values.workTimeData != null && formik.values.workTimeData.endTime) ? formik.values.workTimeData.endTime : ''}
                      &nbsp;
                    </FlexBox>
                      </Table.Cell>
                    </tr>
                  </tbody>
                </Table>
              </Row>
              <Row>
                <Col md={2} offset={{ md: 1 }} style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', color: textColor.main }}>
                  <BodyText>申請理由</BodyText>
                </Col>
                <Col md={6}>
                  <FormField>
                    <TextForm
                      required={false}
                      name="applicationReason"
                      label=""
                      value={String(formik.values.applicationReason)}
                      onChange={formik.handleChange}
                      errorMsg={formik.errors.applicationReason}
                      disable={formik.values.applicationStatus === 0}
                    />
                  </FormField>
                </Col>
              </Row>
              <Row>
                <Col md={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div
                    css={css`
                  .btnAction:nth-of-type(2) {
                    margin-left: 10px;
                  }
                  .btnAction:nth-of-type(3) {
                    margin-left: 10px;
                  }
                `}>
                    <FlexBox>
                      {
                        (isGetHolidayWorkSuccees && (formik.values.modifiyStatus === null || formik.values.modifiyStatus === 0
                          || (formik.values.modifiyStatus === 1 && formik.values.applicationStatus !== 0))) && (
                          <div className="btnAction">
                            <PrimaryButton
                              ghost={false}
                              disabled={formik.values.applicationStatus === 0 && formik.values.createDate != null}
                              text="申請する"
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('buttonType', 0);
                              }}
                            />
                          </div>
                        )
                      }
                      {
                        formik.values.applicationStatus === 0 && (
                          <div className="btnAction">
                            <DeleteButton
                              ghost={false}
                              text="申請キャンセル"
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('buttonType', 1);
                              }}
                            />
                          </div>
                        )
                      }
                      {
                        formik.values.deleteAvailable === true && (
                          <div className="btnAction">
                            <DeleteButton
                              ghost={false}
                              text="削除申請"
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('buttonType', 2);
                              }}
                            />
                          </div>
                        )
                      }
                    </FlexBox>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                  <FlexBox>
                    <Button
                      onClick={() => history.goBack()}
                      text="キャンセル"
                      ghost={true}
                    />
                  </FlexBox>
                </Col>
              </Row>

            </Container>
          </form>
          <ToastModal
            open={toastModalOpen}
            closeHandler={() => setToastModalOpen(false)}
            title={toastMessage}
          />

          <ConfirmModal
            open={confirmApplyModalOpen}
            closeHandler={closeConfirmApplyModal}
            onSubmit={formik.handleSubmit}
            // eslint-disable-next-line no-nested-ternary
            title={formik.values.buttonType === 0 ? (formik.values.modifiyStatus === 0 ? '休日出勤修正を申請' : '休日出勤を申請')
              : formik.values.buttonType === 1 ? '休日出勤キャンセルを申請' : '削除休日出勤を申請'}
            // eslint-disable-next-line no-nested-ternary
            content={formik.values.buttonType === 0 ? (formik.values.modifiyStatus === 0 ? '休日出勤修正を申請します。よろしいですか？' : '休日出勤を申請します。よろしいですか？')
              : formik.values.buttonType === 1 ? '休日出勤キャンセルを申請します。よろしいですか？' : '削除休日出勤を申請します。よろしいですか？'}
            submitText='申請する'
            typeSubmit={formik.values.buttonType === 0 ? 'confirm' : 'reject'}
          />
        </FormContents>

      </BlockUI>

      <div>
        <FormContents customStyle={styles.formContent}>
          <Row style={{ padding: "10px 15px" }}>
            <Col
              md={2}
              xs={12}
              style={{
                fontWeight: "bold",
                fontSize: textFontSize.md,
                lineHeight: "24px",
                paddingBottom: "20px",
                color: textColor.main
              }}>
              更新履歴
                        </Col>
          </Row>
          <TabControl
            isTabModal={true}
            isFixed={false}
            items={changeLogData.map((log, index: number) => {
              return {
                value: String(index),
                display: `ver${log.version}`
              };
            })}
            setValue={setSelectChangelog as (arg: string) => void}
            currentValue={selectChangelog}
            styleNotActive={css({ borderRadius: 0, border: "none", width: "100px", flex: "unset" })}
            styleActive={css({
              borderRadius: 0,
              border: "none",
              borderBottom: "1px solid #007BC3",
              width: "100px",
              flex: "unset"
            })}
          />
          {changeLogData.length > 0 &&
            changeLogData.map((itemLog, index: number) => (
              <div style={{ display: selectChangelog !== String(index) ? "none" : "block" }}>
                <React.Fragment>
                  <FormPadding customStyle={{ fontSize: "14px", color: textColor.mobileTitle }}>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>
                        申請種別:
                                            </Col>
                      <Col md={10} xs={12}>
                        {itemLog.modifiyStatus == 0 ? "申請" : "削除"}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>
                        申請者:
                                            </Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationStaffCode && `${itemLog.applicationStaffCode} `}
                        {itemLog.applicationStaffName && itemLog.applicationStaffName}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>
                        申請日時:
                                            </Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationDate && moment(itemLog.applicationDate).format("YYYY/MM/DD HH:mm:ss")}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>
                        出勤組織:
                                            </Col>
                      <Col md={10} xs={12}>
                        {itemLog.orgCode && itemLog.orgCode}
                        {itemLog.orgName && itemLog.orgName}
                      </Col>
                    </Row>
                    <Row>
                      <AttendHolidayworkModal
                        changeLogData={[itemLog]}
                        selectChangelog={String(index)}
                        customStyle={styles.approvalWrap}
                      />
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>
                        修正理由:
                                            </Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationReason && itemLog.applicationReason}
                      </Col>
                    </Row>
                    {changeLogData.length > 0 && (
                      <Row>
                        <HistoryApprovalTable
                          historyData={itemLog.approvalHistoryList}
                          applicationStatus={itemLog.applicationStatus}
                        />
                      </Row>
                    )}
                  </FormPadding>
                </React.Fragment>
              </div>
            ))}
        </FormContents>
      </div>
    </SidebarTemplate>
  );
};

export default HolidayWorkApplicationPage;
